<ng-container *appValueSelect="queries; empty: emptyTemplate; let query; let next = next; let previous = previous; change: onChange">
	<div class="toolbar">
		<button nz-button nzType="default" [disabled]="previous === undefined" (click)="previous()">
			<i-feather name="chevron-up"></i-feather>
		</button>
		<button nz-button nzType="default" [disabled]="next === undefined" (click)="next()">
			<i-feather name="chevron-down"></i-feather>
		</button>
		<workflow-query-state [state]="query.state"></workflow-query-state>
		<div *ngIf="query.workflowKey" class="question-ref">{{query.workflowKey | questionLabel}}</div>
	</div>
	<workflow-query-timeline [query]="query"></workflow-query-timeline>
	<form *appIfPermission="'query:comment'" nz-form>
		<nz-form-item>
			<nz-form-label nzFor="message">{{'query.edit.comment' | translate}}</nz-form-label>
			<textarea nz-input name="message" [(ngModel)]="message"></textarea>
		</nz-form-item>
		<div class="actions">
			<ng-container [ngTemplateOutlet]="actions?.template" [ngTemplateOutletContext]="{
			$implicit: comment,
			comment: comment,
			query: query,
			message: message
			}"></ng-container>
		</div>
	</form>
</ng-container>
<ng-template #emptyTemplate>
	<div class="empty">
		{{'query.empty' | translate}}
	</div>
</ng-template>